import { notiStore } from '../../routes/(app)/components/noti/notification-store';

export const notifyInfo = (text: string) => {
	notiStore.push('info', {
		props: {
			content: text
		}
	});
};

export const notifyError = (text: string) => {
	notiStore.push('special', {
		props: {
			content: text
		}
	});
};
